import React from 'react';
import { mergeStyles } from '@uifabric/styling';
import { LayerStackProps } from '../schema/LayerStack.types';
const styles = require('./LayerStack.scss');
const classNames = require('classnames/bind').bind(styles);

export default function LayerStack(props: LayerStackProps) {
    const { layers } = props;

    return (
        <>
            {layers?.map(layer => {
                const { key, view, depth, disablePointerEvents, ariaHidden = true } = layer;
                return (
                    !!view && (
                        <div
                            aria-hidden={ariaHidden ? 'true' : 'false'}
                            className={classNames(
                                styles.layer,
                                !!layer.depth &&
                                    mergeStyles({
                                        zIndex: depth,
                                    }),
                                mergeStyles({
                                    pointerEvents: disablePointerEvents ? 'none' : 'auto',
                                })
                            )}
                            key={key}>
                            {view}
                        </div>
                    )
                );
            })}
        </>
    );
}
